// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactForm_wrapper__-Umw-","btn":"ContactForm_btn__wll+u"};